import { createMuiTheme } from '@material-ui/core/styles';

export const white = '#fff'; // eslint-disable-line
export const liraBlue = '#2d4b8c'; // eslint-disable-line
export const antennaBlue = '#0aafe1';
export const liraEmph = '#ffea00';

export const mui = createMuiTheme({
  typography: {
    useNextVariants: true,
  },

  palette: {
    primary: {
      main: antennaBlue,
      contrastText: '#fafafa'
    },
    secondary: {
      main: liraEmph
    }
  }
});
